import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Input from "../components/input";
import Button from "../components/button";
import { forgotPassword, resetPassword } from "../api/endpoint";
import { useSelector } from "react-redux";
import axios from "axios";

const ResetPasswordModal = ({ isResetPasswordOpen, closeModal }) => {
  const [email, setEmail] = useState("");
  const [otpReceived, setOtpReceived] = useState(false);
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [errors, setErrors] = useState({
    email: "",
    otp: "",
    newPassword: "",
  });
  const { auth } = useSelector((state) => state.login);

  const getOtp = (e) => {
    e.preventDefault();
    if (!email) {
      setErrors({
        ...errors,
        email: "Email is required",
      });
      return;
    }
    if (email.includes(" ")) {
      setErrors({
        ...errors,
        email: "Email should not include spaces",
      });
      return;
    }
    if (email) {
      fetchOtp();
    }
  };

  const fetchOtp = async () => {
    try {
      const response = await axios.get(forgotPassword, {
        params: { identifier: email },
      });
      setOtpReceived(true);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    if (!otp) {
      setErrors({
        ...errors,
        otp: "OTP is required",
      });
      return;
    }
    if (!newPassword) {
      setErrors({
        ...errors,
        newPassword: "New Password is required",
      });
      return;
    }
    if (newPassword?.includes(" ")) {
      setErrors({
        ...errors,
        newPassword: "Password should not contain spaces",
      });
      return;
    }
    const body = {
      email: email,
      otp: otp,
      newPassword: newPassword,
    };

    try {
      const response = await axios.post(resetPassword, body);
      setOtpReceived(true);
    } catch (error) {
      console.error("Error resetting password:", error);
    }
  };

  return (
    <Modal
      show={isResetPasswordOpen}
      onHide={closeModal}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Reset Password</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {otpReceived == false && (
          <>
            <Input
              label="Enter Email"
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            {errors?.email && (
              <div className="text-danger">{errors?.email}</div>
            )}
            <div className="text-end mt-3">
              <Button text="Send OTP" callBack={(e) => getOtp(e)} />
            </div>
          </>
        )}
        {otpReceived && (
          <div className="mt-3">
            <Input
              label="OTP"
              type="text"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />
            {errors?.otp && (
              <div className="mb-3 text-danger">{errors?.otp}</div>
            )}
            <Input
              label="New Password"
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
            {errors?.newPassword && (
              <div className="text-danger">{errors?.newPassword}</div>
            )}
            <div className="text-end">
              <Button
                text="Reset Password"
                callBack={(e) => handleResetPassword(e)}
                className="mt-3"
              />
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ResetPasswordModal;
